import React from 'react';
import '../styles/index.css';
import TestimoinalVideoItem from './TestimoinalVideoItem';

export default function VideoTestimonialSection({ variant }) {
  const defaultData = [
    {
      id: 'arav-joshi',
      name: 'Arav Joshi ',
      country: 'India',
      flag: 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/in.svg',
      video: '/Assets/images/videos/arav-joshi-orginal.mp4',
      thumbnail: '/Assets/images/reviewThumbnails/ReviewerAravJoshi.jpg',
      videoDescription:
        'Hello, I am Aarav Joshi. Log2Base2 is a very good website. I have tried many such websites for programming but i found this one the best. I just wanted to say that for the binary coding part, we could just add a little more exercises because then children will be able to learn more new things from it. I also wanted to say that the example which you give during every video is very good. And I like the part where you share many images because then people get attracted towards it and they want to see what happens next. And in every video, you give a conclusion. That is also a very nice thing. Thank you for such a great website and keep up the good work.',
    },
  ];

  return (
    <div className="video-tstmnl-row">
      {defaultData.map((data) => {
        return <TestimoinalVideoItem key={data.id} data={data} variant={variant} />;
      })}
    </div>
  );
}
